/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
// vendors
import React, { useEffect, useState, useMemo } from 'react';

// lego
import { Tabs, Icon, PhotoUploader } from 'lego-dist';

// components
import Dialog from 'components/dialog/Dialog';
import ResultActionModal from 'components/shared/ResultActionModal/ResultActionModal';
import GeneralInfoForm from './GeneralInfoForm';

// constants
import { FILES_API_URL, AWS_REGION, S3_BUCKET_FILES, AWS_KEY } from 'config';

// hooks
import { useRouter } from 'routes';
import { useTranslation, Trans } from 'react-i18next';
import useOrganization from 'hooks/UseOrganization';
import useStaff from 'hooks/UseStaff';

// styles
import { Container, ContentContainer } from './styles/MemberProfileContainer';
import { Header, Title } from './styles/MemberProfileHeader';
import {
  MemberName,
  MemberRole,
  AvatarSectionContainer,
} from './styles/MemberProfileAvatarSection';
import {
  Row,
  Col,
  StylesImageModalResultsUpdateMember,
} from './styles/Commons';
import { Dropdown, DropdownItem } from './styles/MemberProfileDelete';
import { APP_SECTIONS_PATHS } from 'constants/routes';
import RendererIf from 'components/RendererIf';

import updateErrorImage from 'images/error.svg';
import updateSuccessImage from 'images/checked.svg';
import Breadcrumbs from 'components/shared/Breadcrumbs';
import themes from 'themes';
import SettingsForm from './SettingsForm';
import useCurrentUser from 'hooks/useCurrentUser';
import { ActionPermission, UserType } from 'lib/specialPermissions';
import { IETabValues } from 'components/settings/center/CenterView';

const tabs = [
  {
    freemium: true,
    type: 'General',
    label: (
      <Trans>
        settings:GENERAL
      </Trans>
    ),
    View: GeneralInfoForm,
  },
  {
    freemium: true,
    disabled: false,
    View: SettingsForm,
    label: (
      <Trans>
        settings:CONFIG
      </Trans>
    ),
    type: 'Configuration',
  },
];

let uploadUserAvatarToS3: any;

function EditMember() {
  const { t: translate } = useTranslation();
  const [CurrentTab, setCurrentTab] = useState(tabs[0]);
  const [currentMember, setCurrentMember] = useState<any>({});
  const [titleForm, setTitleForm] = useState<string>(
    translate('settings:STAFF_SECTION.MANAGE.EDIT_MEMBER_VIEW.TITTLE'),
  );
  const [actionPermissionEditMember, setActionPermissionEditMember] = useState<
    boolean
  >(true);
  const { can } = useCurrentUser();

  const [showDeleteTeacherModal, setShowDeleteTeacherModal] = useState(false);
  const [showResultActionModal, setShowResultActionModal] = useState<any>(
    false,
  );
  const {
    navigateTo,
    currentParamsRef: {
      current: { centerName, centerId, userType, userId, origin },
    },
  } = useRouter();
  const {
    updateAdmins,
    fetchAdmin,
    fetchOwner,
    organization,
  } = useOrganization();
  const { getDirectorDetail, deleteStaff } = useStaff();
  const ConfigResultActionModal = {
    success: {
      title: translate('common:SUCCESS'),
      image: updateSuccessImage,
      configPopsModal: {
        showCloseButton: false,
        onClosedModal: () => {
          if (setShowResultActionModal) setShowResultActionModal(false);
        },
      },
    },
    error: {
      title: translate('common:ERROR'),
      image: updateErrorImage,
      configPopsModal: {
        showCloseButton: true,
        onClosedModal: () => {
          if (setShowResultActionModal) setShowResultActionModal(false);
        },
      },
    },
  };

  const [statusResultActionModal, setStatusResultActionModal] = useState<any>(
    ConfigResultActionModal.error,
  );

  const onClickTab = ({ currentSelected }: any) => {
    if (currentSelected) {
      setCurrentTab(currentSelected);
    }
  };

  /* Breadcrumb links */
  const breadcrumbLinks = [
    { name: translate('settings:SETTINGS'), url: APP_SECTIONS_PATHS.SETTINGS },
    {
      name: origin === 'staff' ? translate('settings:ADMINS') : centerName || translate('settings:CENTER_SECTION.CENTER'),
      url: origin === 'staff' ? `${APP_SECTIONS_PATHS.SETTINGS}?tab=staff` : `${APP_SECTIONS_PATHS.CENTER_SETTINGS}?centerId=${centerId}&centerName=${centerName}`,
    },
  ];

  const onUploadedTeacherAvatar = (s3filePath: string, croppedFile: any) => {
    const s3_files_attributes = [
      {
        file_name: s3filePath,
        status: 'Complete',
        mime_type: croppedFile.type,
        service_urls_attributes: [
          {
            record_type: 'thumbnail_url',
            url: s3filePath,
          },
        ],
      },
    ];

    updateAdmins({
      data: { s3_files_attributes, type: currentMember.type },
      centerId,
      directorId: currentMember.id,
    });
    return s3_files_attributes;
  };

  const handleOnDeleteMember = () => {
    deleteStaff(userId)
      .then(() => {
        if(origin === 'staff') {
          navigateTo(`${APP_SECTIONS_PATHS.SETTINGS}`, {
            section: 'staff',
          });
        } else {
          navigateTo(APP_SECTIONS_PATHS.CENTER_SETTINGS, {
            centerId,
            centerName,
            tab: userType === 'Teacher' ? IETabValues.TEACHERS : IETabValues.DIRECTORS
          });
        }
      })
      .finally(() => setShowDeleteTeacherModal(false));
  };

  const handleOnSubmitGeneralInfoForm = (data: any) => {
    return updateAdmins({
      data: {
        ...data,
        ...{
          type: currentMember.type === UserType.OWNER ? currentMember.type : data.type,
          center_ids: userType === UserType.OWNER ? undefined : data.center_ids
        },
      },
      centerId,
      directorId: currentMember.id,
    })
      .then(({ user }:any) => {
        if (user?.id) {
          setStatusResultActionModal(ConfigResultActionModal.success);
          setCurrentMember(user);
        } else {
          setStatusResultActionModal(ConfigResultActionModal.error);
        }
      })
      .finally(() => setShowResultActionModal(new Date()));
  };

  const handleBeforeSendReinvite = (data: any) => {
    return updateAdmins({
      data: { email: data, type: currentMember.type },
      centerId,
      directorId: currentMember.id,
    });
  };

  const renderDeleteTeacherModal = () => (
    <Dialog
      mainText={translate('common:DELETE')}
      cancelText={translate('common:CANCEL')}
      title={translate(
        'settings:STAFF_SECTION.MANAGE.EDIT_MEMBER_VIEW.MODAL_DELETE.TITLE',
      )}
      show={showDeleteTeacherModal && userId}
      onMainAction={handleOnDeleteMember}
      onDialogClose={() => setShowDeleteTeacherModal(false)}
      onCancelAction={() => setShowDeleteTeacherModal(false)}
    >
      <>
        {translate(
          'settings:STAFF_SECTION.MANAGE.EDIT_MEMBER_VIEW.MODAL_DELETE.TEXT',
        )}
      </>
    </Dialog>
  );

  useEffect(() => {
    if (userId && userType === 'Admin') {
      setTitleForm(
        translate(
          'settings:STAFF_SECTION.MANAGE.EDIT_MEMBER_VIEW.ADMIN_TITTLE',
        ),
      );
      setActionPermissionEditMember(can(ActionPermission.EDIT_TEACHERS));
      fetchAdmin(userId).then((response) => {
        setCurrentMember(response?.user || {});
      });
    } else if (userId && userType === 'Owner') {
      fetchOwner().then((response) => {
        setCurrentMember(response?.user || {});
      });
    } else if (userId && userType === 'Director') {
      setActionPermissionEditMember(can(ActionPermission.EDIT_DIRECTORS));
      setTitleForm(
        translate(
          'settings:STAFF_SECTION.MANAGE.EDIT_MEMBER_VIEW.DIRECTOR_TITTLE',
        ),
      );
      getDirectorDetail(userId, centerId).then((response) => {
        setCurrentMember(response?.user || {});
      });
    }
  }, [userId, userType]);

  const canDelete = useMemo(() => userType !== 'Owner', [userType]);

  return (
    <Container>
      <Breadcrumbs links={breadcrumbLinks} />

      <RendererIf condition={showResultActionModal}>
        <ResultActionModal
          styles={{ Image: StylesImageModalResultsUpdateMember }}
          {...statusResultActionModal}
        />
      </RendererIf>

      {renderDeleteTeacherModal()}
      <ContentContainer>
        <Header>
          <Title>{titleForm}</Title>
          <RendererIf condition={canDelete}>
            <Dropdown
              noPaddingContent
              contentWidth={100}
              showIndicator={false}
              content={({ close }: any) => (
                <DropdownItem
                  onClick={() => {
                    setShowDeleteTeacherModal(true);
                    close();
                  }}
                >
                  {translate('common:DELETE')}
                </DropdownItem>
              )}
              title={() => <Icon name="ThreeDots" size="20" />}
            />
          </RendererIf>
        </Header>
        <AvatarSectionContainer disable={!actionPermissionEditMember}>
          <PhotoUploader
            multipart
            previewModalProps={{ headerColor: themes.colors.newKinedu }}
            src={currentMember?.avatar}
            onCroppedFile={({ uploadFileToS3, croppedFile }: any) => {
              uploadUserAvatarToS3 = () => uploadFileToS3(croppedFile);
            }}
            positiveButtonProps={{
              children: translate('SAVE'),
              onClickButton: () => {
                uploadUserAvatarToS3();
              },
            }}
            negativeButtonProps={{
              children: translate('CANCEL'),
            }}
            onUploadedFile={({ s3FilePath, croppedFile }: any) =>
              onUploadedTeacherAvatar(s3FilePath, croppedFile)
            }
            s3UploaderProps={{
              apiURL: FILES_API_URL,
              awsRegion: AWS_REGION,
              bucket: S3_BUCKET_FILES,
              aws_key: AWS_KEY,
            }}
            s3path={`${
              localStorage?.ORGANIZATION_ID
            }/avatars/teachers/${Date.now()}_${currentMember?.id}_`}
          />
          <Col>
            <MemberName>
              {currentMember?.name} {currentMember?.lastname}
            </MemberName>
            <MemberRole>
              {currentMember?.role_alias || currentMember?.type}
            </MemberRole>
          </Col>
        </AvatarSectionContainer>

        <RendererIf condition={tabs.length > 1}>
          <Row id="MemberProfileTabs">
            <Tabs items={tabs} active={CurrentTab} onClickItem={onClickTab} />
          </Row>
        </RendererIf>
        {currentMember?.id && (
          <CurrentTab.View
            memberData={currentMember}
            centers={organization?.centers}
            handleOnSubmitGeneralInfoForm={handleOnSubmitGeneralInfoForm}
            beforeSendReinvite={handleBeforeSendReinvite}
          />
        )}
      </ContentContainer>
    </Container>
  );
}

// eslint-disable-next-line import/prefer-default-export
export { EditMember };
